import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type stepperState = {
  currentPage: number;
  quotationHistoryPage: number;
};

export const initialState: stepperState = {
  currentPage: 0,
  quotationHistoryPage: 0,
};

const steppersSlice = createSlice({
  name: 'stepper',
  initialState,
  reducers: {
    updateCurrentPage: (state, action: PayloadAction<number>): void => {
      state.currentPage = action.payload;
    },
    updateQuotationHistoryPage: (
      state,
      action: PayloadAction<number>,
    ): void => {
      state.quotationHistoryPage = action.payload;
    },
  },
});

export const { updateCurrentPage, updateQuotationHistoryPage } =
  steppersSlice.actions;

export default steppersSlice.reducer;
